import type { Level } from "./levelTypes";

export const EXAMPLE_LEVELS: Level[] = [
  // ── WordMatch ──────────────────────────────────────────────────────────────
  {
    id: "siida-1",
    type: "wordmatch",
    title: "Familiebegreper",
    questions: [
      { word: "eadni",  translation: "mor",    imageUrl: "/images/mother.svg" },
      { word: "áhčči",  translation: "far",    imageUrl: "/images/father.svg" },
      { word: "oabbá",  translation: "søster", imageUrl: "/images/sister.svg" },
      { word: "viellja", translation: "bror",  imageUrl: "/images/brother.svg" },
      { word: "áhkku",  translation: "bestemor", imageUrl: "/images/grandmother.svg" },
    ],
    goldReward: { base: 10, perfect: 5, timed: 3 },
    timeLimit: 60,
  },

  // ── Translation ────────────────────────────────────────────────────────────
  {
    id: "siida-2",
    type: "translation",
    title: "Skriv på samisk",
    questions: [
      { word: "eadni",    translation: "mor" },
      { word: "áhčči",   translation: "far" },
      { word: "siida",   translation: "bosetning / familie-gruppe" },
      { word: "goahti",  translation: "lavvo / telt" },
      { word: "mánná",   translation: "barn" },
    ],
    goldReward: { base: 12, perfect: 6 },
  },

  // ── SentenceBuilder ────────────────────────────────────────────────────────
  {
    id: "siida-3",
    type: "sentencebuilder",
    title: "Bygg setningen",
    questions: [
      { words: ["Mun",  "lean",    "oahppi"],      translation: "Jeg er elev" },
      { words: ["Son",  "lea",     "eadni"],        translation: "Hun er mor" },
      { words: ["Mii",  "eat",     "dieđe"],        translation: "Vi vet ikke" },
      { words: ["Siida", "lea",    "min",  "ruoktu"], translation: "Siida er vårt hjem" },
    ],
    goldReward: { base: 14, perfect: 7, timed: 4 },
    timeLimit: 90,
  },

  // ── MultipleChoice ─────────────────────────────────────────────────────────
  {
    id: "siida-4",
    type: "multiplechoice",
    title: "Hva betyr det?",
    questions: [
      {
        question: "Hva betyr «siida»?",
        options: ["Fjell", "Familie-bosetning", "Fisk", "Lavvo"],
        correctIndex: 1,
      },
      {
        question: "Hvordan sier man «mor» på nordsamisk?",
        options: ["áhčči", "oabbá", "eadni", "viellja"],
        correctIndex: 2,
      },
      {
        question: "Hva betyr «goahti»?",
        options: ["Elv", "Reinsdyr", "Lavvo / telt", "Bær"],
        correctIndex: 2,
      },
      {
        question: "Hva er det samiske ordet for «barn»?",
        options: ["mánná", "goahti", "siida", "duottar"],
        correctIndex: 0,
      },
    ],
    goldReward: { base: 10, perfect: 5 },
  },
];

export const LEVELS_BY_ID: Record<string, Level> = Object.fromEntries(
  EXAMPLE_LEVELS.map((l) => [l.id, l])
);
